module.exports = __webpack_public_path__ + "static/media/instagram.f2dc2633.svg";